module.exports = __webpack_public_path__ + "img/nopro.20328797.png";